<template>
      <div class="breadcrumbs-container">
            <ToolButton 
                v-for="( item, index ) in path" 
                :key="item.instance_id" 
                @click="index===path.length-1 ? undefined : toNode(item, index)" 
                :style="'z-index:'+(path.length-index)+';'"
                :btn-class="'breadcrumbs-item '+ ((index === path.length || item.elemID || ( item.instance_id < 1 )) ? 'active' : '')" 
                :title="modelName( item )"
                :light="!item.isProj"
                :disabled="!item.isProj && index === path.length-1"
                noTr/>
    </div>
</template>

<script>
import{ conf } from '../utils/confTruePLM';
import ToolButton from './ToolButton.vue';

export default {
  name: 'BreadcrumbsLine',
  props: {
      noSave: Boolean
  },
  data () {
    return {
        path: []
    };
  },
  components: {
    ToolButton: ToolButton
  },
  methods: 
  {
      modelName: function( model )
      {
            var rez = model.name;
            if( model.alt_name )
                rez = model.alt_name;
            else if( !model.isProj && !model.parent && this.$globalStore.state.actVer )
                rez += ' (ver.' + this.$globalStore.state.actVer + ')';
            else if( !model.parent && !this.$globalStore.state.actVer && model.version_id )
                rez += ' (ver.' + model.version_id + ')';
            return rez;
      },
      toNode: function( node, index ) {
          if ((node.isProj || node.instance_id > 0) && !(index==0 && this.noSave) ) {
              this.$eventBus.$emit( 'goInNode', node ); 
              this.path.splice( index + 1, Number.MAX_VALUE );
          }
      },
      saveCurrentPath: function()
      {
          if( this.noSave )
              return;
          
          var ids = [];
          for( var i = 1; i < this.path.length; i++ )
              ids.push( this.path[ i ].instance_id );
          
          localStorage.setItem( 'curr_path', JSON.stringify( ids ) );
      }
  },
  mounted: function() 
  { 
      var self = this;
      self.$eventBus.$on( 'selectedModel', function()
      {
          var model = conf.getProj();
          model.in_project.isProj = true;
          self.path = [ model.in_project ];
          self.saveCurrentPath();
      });
      
      self.$eventBus.$on( 'goInProd', function( model )
      {
          if( self.path[ self.path.length - 1 ].elemID !== model.elemID )
              self.path.push( model );
          self.saveCurrentPath();
      });
      
      self.$eventBus.$on( 'goInNode', function( model )
      {
          if( self.path[ self.path.length - 1 ].instance_id !== model.instance_id )
              self.path.push( model );
          self.saveCurrentPath();
      });
      
      self.$eventBus.$on( 'goOutNode', function( /*model*/ )
      {
          self.path.pop();
          self.saveCurrentPath();
      });
      
      self.$eventBus.$on( 'showNodeTree', function()
      {
          self.$eventBus.$emit( 'showPathAsTree', self.path );  
      });
      
      self.$eventBus.$on( 'showBOM', function()
      {
          self.$eventBus.$emit( 'showBOMFromPath', self.path );  
      });
      
      self.$eventBus.$on( 'openBaseline', function( bsl )
      {
          self.path.splice( 1, Number.MAX_VALUE, { name: 'Baseline', instance_id: 0, version_id: bsl.root_bkdn_elem.version_id } );
          bsl.root_bkdn_elem.alt_name = bsl.id;
          self.path.push( bsl.root_bkdn_elem );
      });
      
      self.$eventBus.$on( 'setPath', function( newPath )
      {
          newPath.unshift( self.path[ 0 ] );
          self.path = newPath;
          self.saveCurrentPath();
      });
  },   
  beforeDestroy: function()
  {
      this.$eventBus.$off( 'openBaseline' );
      this.$eventBus.$off( 'selectedModel' );
      this.$eventBus.$off( 'goInProd' );
      this.$eventBus.$off( 'goInNode' );
      this.$eventBus.$off( 'goOutNode' );
      this.$eventBus.$off( 'setPath' );
      this.$eventBus.$off( 'showNodeTree' );
      this.$eventBus.$off( 'showBOM' );
  }
}
</script>

<style scoped>
    .breadcrumbs-container{
        display: inline-flex;
        flex-wrap: wrap;
        row-gap: 4px;
        overflow: hidden;
        padding-right: 8px;
        flex: 1 1;
    }

    .breadcrumbs-container >>> button.breadcrumbs-item{
        z-index: 1;
        height: 30px;
        border-top-right-radius: 999px;
        border-bottom-right-radius: 999px;
        margin-left: -20px;
        padding-left: 30px;
        color: #606060 !important;
    }

    .breadcrumbs-container >>> button.breadcrumbs-item.active{
        display: none;
    }

    .breadcrumbs-container >>> button.breadcrumbs-item:not(.active){
        font-weight: 400;
        -webkit-box-shadow: 6px 0px 6px -4px rgba(0,0,0,0.25);
        -moz-box-shadow: 6px 0px 6px -4px rgba(0,0,0,0.25);
        box-shadow: 6px 0px 6px -4px rgba(0,0,0,0.25);
    }

    .breadcrumbs-container >>> .active
    {
        color: #999;
        cursor: text;
    }
</style>
